import {defineStore} from 'pinia';
import backendCall from "../services/AxiosService";

// Define interfaces for type safety
interface Track {
    id: string;
    track_id: string;
    name: string;
    yard: string;
    full_road_access: boolean;
    partial_road_access: boolean;
    intermodal_pad_track: boolean;
    is_special_risk: boolean;
    special_risk_text: string;
    [key: string]: any;
}

interface Alarm {
    id: number;
    name: string;
    [key: string]: any;
}

interface UserRole {
    id: number;
    name: string;
    [key: string]: any;
}

interface CNPowerPack {
    id: number;
    name: string;
    [key: string]: any;
}

interface ClipOn {
    id: number;
    name: string;
    [key: string]: any;
}

interface Company {
    id: number;
    name: string;
    [key: string]: any;
}

interface JobType {
    job_type_id: number;
    name: string;
    rate: number;
    [key: string]: any;
}

export const useReferenceStore = defineStore('referenceStore', {
    state: () => ({
        tracks: [] as Track[],
        alarms: [] as Alarm[],
        userRoles: [] as UserRole[],
        cnPowerPacks: [] as CNPowerPack[],
        clipOns: [] as ClipOn[],
        companies: [] as Company[],
        jobTypes: [] as JobType[],
    }), actions: {
        async fetchReferenceData() {
            try {
                const response = await backendCall.get('reference-data');
                const referenceDataResponse = response.data.data;

                this.tracks = referenceDataResponse.tracks;
                this.alarms = referenceDataResponse.alarms;
                this.userRoles = referenceDataResponse.availableUserRoles;
                this.cnPowerPacks = referenceDataResponse.cnPowerPacks;
                this.clipOns = referenceDataResponse.clipOns;

                // Add companies data if available
                if (referenceDataResponse.companies) {
                    this.companies = referenceDataResponse.companies;
                }

                return response;
            } catch (error) {
                console.error('There was a problem with the axios operation:', error);
                throw error;
            }
        },

        async fetchCompanies() {
            // Only fetch companies if they're not already loaded
            if (this.companies.length === 0) {
                try {
                    const response = await backendCall.get('reference-data/companies');
                    if (response.data && response.data.success && response.data.data) {
                        this.companies = response.data.data;
                    }
                } catch (error) {
                    console.error('Error fetching companies:', error);
                    throw error;
                }
            }
            return this.companies;
        }
    },

});
